import { createSlice } from '@reduxjs/toolkit';
import type { SsccSettingDto } from '../../services/api/ssccService';
import { listSsccSettings } from '../thunks/ssccThunks';

// ============================================================================
// SSCC settings slice — Spec mlinkone-sscc-allocation. Holds the settings list
// for the current scope + load status. Mutations refresh via listSsccSettings.
// ============================================================================

export interface SsccState {
  settings: SsccSettingDto[];
  listStatus: 'idle' | 'loading' | 'success' | 'failure';
  loadError: string | null;
}

const initialState: SsccState = {
  settings: [],
  listStatus: 'idle',
  loadError: null,
};

const ssccSlice = createSlice({
  name: 'sscc',
  initialState,
  reducers: {
    resetSscc: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(listSsccSettings.pending, (state) => {
        state.listStatus = 'loading';
        state.loadError = null;
      })
      .addCase(listSsccSettings.fulfilled, (state, action) => {
        state.listStatus = 'success';
        state.settings = action.payload;
      })
      .addCase(listSsccSettings.rejected, (state, action) => {
        state.listStatus = 'failure';
        state.loadError = (action.payload as string) ?? action.error.message ?? 'Failed to load SSCC settings';
      });
  },
});

export const { resetSscc } = ssccSlice.actions;
export default ssccSlice.reducer;
